var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-row',[_c('el-col',{attrs:{"span":24}},[_c('header',[_c('div',[_c('heads')],1)]),_c('router-view'),_c('footers')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }